import React from 'react'

const PartEleven = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 8 การบอกเลิกสัญญา และการเรียกค่าเสียหาย</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.1 ก่อนหรือระหว่างที่ดำเนินการก่อสร้างตามสัญญานี้ หากเกิดกรณีใดกรณีหนึ่งหรือหลายกรณี เช่นที่จะกล่าวดังต่อไปนี้ ผู้ว่าจ้างหรือผู้รับจ้างมีสิทธิ์บอกเลิกสัญญาจ้างก่อสร้างนี้ โดยบอกกล่าวเป็นลายลักษณ์อักษรล่วงหน้าไม่น้อยกว่า 30 วัน
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.1.1 ผู้รับจ้างตกเป็นบุคคลล้มละลาย หรือมีคำพิพากษาถึงที่สุดให้ล้มลุลาย
                </p> 
            </div>
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.1.2 ผู้รับจ้างหยุดงานก่อสร้างติดต่อกันเกินกว่า 30 วัน หรือละทิ้งงานโดยไม่มีเหตุผลสมควร และผู้ว่าจ้างมีสิทธิ์เรียกเงินที่ผู้ว่าจ้างได้ชำระไปแล้วในงวดงานที่ผู้รับจ้างยังไม่ได้ดำเนินการรวมถึงค่าเสียหายอื่นๆ
                </p> 
            </div>
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.1.3 ผู้ว่าจ้างผิดสัญญาไม่ชำระเงินงวดใดงวดหนึ่งตามหมวดที่ 3 เกินระยะเวลา 30 วันนับจากวันส่งงวดงาน
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.2 เมื่อผู้ว่าจ้างได้บอกเลิกสัญญาแล้วตามข้อ 8.1.1 หรือ 8.1.2 แล้ว และมีสิทธิ์เรียกร้องค่าเสียหายจากผู้รับจ้างได้
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.3 เมื่อผู้รับจ้างได้บอกเลิกสัญญาตามข้อ 8.1.3 แล้ว และมีสิทธิ์เรียกร้องค่าเสียหายจากผู้ว่าจ้างได้โดยทรัพย์สิน อุปกรณ์เครื่องมือที่ใช้ในงานก่อสร้าง รวมทั้งบรรดาสิ่งของต่างๆ ที่ผู้รับจ้างดำเนินการก่อสร้างไปแล้ว จะเสร็จสิ้นตามแบบหรือไม่ก็ตาม ผู้ว่าจ้างยินยอมให้ตกเป็นกรรมสิทธิ์ของผู้รับจ้างทั้งหมด (ยกเว้นในส่วนที่ผู้ว่าจ้างชำระเงินแล้วตาม หมวดที่ 3)
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartEleven